import React, { useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BlockUnblockModal } from '..';
import { isBlockBlockedProfile } from '../../redux/actions/auth';

import styles from './LiveShowPlaylist.module.css';
import PlaylistViewContent from '../PlaylistPageView/PlaylistViewContent';

const LiveShowPlaylist = ({
  match,
  title,
  data,
  fetchNextData,
  completed,
  searchView,
  handleViewAll,
  allowSeeAll = true,
  history,
}) => {
  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth);
  const { channelID } = match.params;
  const [isTriggerBlockModal, setTriggerBlockModal] = useState(false);
  const [blockType, setBlockType] = useState('block');
  const [profile, setProfile] = useState(null);

  const checkBlockUnblock = useCallback(
    async (data) => {
      if (!token && !user) {
        return data && history.push(`/liveshow/${data.id}`);
      }
      const res = await dispatch(
        isBlockBlockedProfile(data.profile.accountId, data.profile.id)
      );
      if (res?.data?.status === 'BLOCKING') {
        setProfile(data.profile);
        setBlockType('unblock');
        setTriggerBlockModal(true);
        return false;
      }
      if (res?.data?.status === 'BLOCKED') {
        setProfile(data.profile);
        setTriggerBlockModal(true);
        setBlockType('access');
        return false;
      }

      return history.push(`/liveshow/${data.id}`);
    },
    [dispatch, history, token, user]
  );

  const handleSelectChannel = useCallback(
    (item) => {
      if (item) {
        checkBlockUnblock(item);
      }
    },
    [checkBlockUnblock]
  );

  const onCloseBlockModal = (type) => {
    if (type === 'blocked' || type === 'unblocked') {
      window.location.reload();
    }

    if (type === 'cancel') {
      setTriggerBlockModal(false);
      setProfile(null);
    }
    setTriggerBlockModal(false);
  };

  return (
    <div className={styles['wrapper']}>
      {!channelID && (
        <PlaylistViewContent
          data={data}
          title={title}
          searchView={searchView}
          allowSeeAll={allowSeeAll}
          handleViewAll={handleViewAll}
          completed={completed}
          fetchNextData={fetchNextData}
          handleSelectChannel={handleSelectChannel}
          maxItemsPerRow={8}
        />
      )}
      {profile && (
        <BlockUnblockModal
          profile={profile}
          blockType={blockType}
          isTriggered={isTriggerBlockModal}
          onClose={onCloseBlockModal}
        />
      )}
    </div>
  );
};

export default withRouter(LiveShowPlaylist);
